/**
 * localStorage access that never throws.
 *
 * Browsers that block storage — Safari Private mode, Instagram/Facebook in-app
 * webviews, partitioned webviews — throw a `SecurityError` the moment
 * `localStorage` is touched. An unguarded read at module-load time therefore
 * crashes the bundle and blanks the whole app before anything renders (e.g. a
 * store's initial state reading a persisted value). These helpers degrade to a
 * null read / no-op write instead, so a blocked store can never take the app
 * down.
 */

export const safeGetLocalStorage = (key: string): string | null => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export const safeSetLocalStorage = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* storage blocked — ignore */
  }
}

export const safeRemoveLocalStorage = (key: string): void => {
  try {
    localStorage.removeItem(key)
  } catch {
    /* storage blocked — ignore */
  }
}
